export var Stepped;
(function (Stepped) {
    let cmd_state_type;
    (function (cmd_state_type) {
        cmd_state_type["STEP"] = "step";
    })(cmd_state_type = Stepped.cmd_state_type || (Stepped.cmd_state_type = {}));
})(Stepped || (Stepped = {}));
